<ng-container *ngIf="preloaderActive; else content">
  <div class="loader-plug-wrapper loader-plug-wrapper--header" prlwResponsive>
    <div class="loader-plug loader-plug--basis"></div>
    <div class="loader-plug"></div>
  </div>
</ng-container>

<ng-template #content>
  <prlw-table-header-ui
    *ngIf="reqInstrumentsResult"
    [gridSize]="gridSize"
    cdkDropList
    cdkDropListOrientation="horizontal"
    cdkDropListLockAxis="x"
    (cdkDropListDropped)="drop($event)"
    prlwResponsive
  >
    <prlw-table-column-header-ui
      cdkDrag
      cdkDragLockAxis="x"
      [cdkDragDisabled]="xsmall$ | async"
      *ngFor="let column of columns"
      [columnName]="column.name"
      [isBasis]="isBasis(column.id)"
      [indicator]="getIndicator(column.id)"
      [isActionActive]="isActionActive(column.id)"
      [hasAction]="hasAction(column.id)"
      [isActionChanged]="isActionChanged(column.id)"
      [hasSorting]="hasSorting(column.id)"
      [isDesSort]="isDesSort"
      [isModifierChanged]="isModifierChanged ?? false"
      (click)="sortColumn.emit(column.id)"
      (openModifiersOverlay)="openModifiersOverlay.emit()"
      data-cy="table-column-header"
      [class.is-basis]="isBasis(column.id)"
      prlwResponsive
    >
    </prlw-table-column-header-ui>
  </prlw-table-header-ui>
</ng-template>
